import { useState } from "react";
import bannerImg from "../assest/description_top_banner.png";
import mainImg from "../assest/h1.png";
import t1 from "../assest/thum1.png";
import t2 from "../assest/thum2.png";
import t3 from "../assest/thum3.png";
import t4 from "../assest/description_top_banner.png";
import t5 from "../assest/thum5.png";
import Footer from "./footer";
import { NavLink } from "react-router-dom";
export default function ProjectDetails() {
  const [activeImg, setActiveImg] = useState(mainImg);

  const thumbs = [t1, t2, t3, t4, t5];

  return (
    <div className="bg-[#f4f4f4] font-poppins">
      {/* TOP BANNER */}
      <div className="w-full h-[150px] md:h-[260px] overflow-hidden">
        <img src={bannerImg} className="w-full h-full object-cover" />
      </div>

      {/* SECTION */}
      <section className="bg-white py-[60px] md:py-[100px] px-4">
        <div className="max-w-[1200px] mx-auto relative">
          {/* BACK BUTTON */}
          <div className="absolute left-2 md:-left-[55px] top-[-40px] md:top-[130px] w-[40px] h-[40px] md:w-[45px] md:h-[45px] bg-white rounded-full flex items-center justify-center shadow-lg cursor-pointer hover:bg-[#8a6fd1] hover:text-white transition">
             <a href="/Ourproject">❮ </a>
          </div>

          {/* MAIN CONTAINER */}
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-[70px] items-center">
            {/* LEFT IMAGE */}
            <div className="flex-1 w-full">
              <img src={activeImg} className="w-full rounded-xl shadow-lg" />

              {/* THUMBNAILS */}
              <div className="grid grid-cols-2 md:flex md:flex-row gap-3 mt-2 md:ml-10">
                {thumbs.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    onClick={() => setActiveImg(img)}
                    className="w-full h-[60px] md:w-[80px] md:h-[60px] object-cover rounded-md border-2 border-gray-600 shadow cursor-pointer hover:scale-105 transition"
                  />
                ))}
              </div>
            </div>

            {/* RIGHT DETAILS */}
            <div className="flex-1 w-full bg-white p-4 md:p-8 rounded-xl">
              <h2 className="text-[22px] md:text-[32px] font-semibold mb-6">
                Mr. & Mrs Rout
              </h2>

              {/* GRID START */}
              <ul className="grid grid-cols-2 gap-6">
                <li className="flex gap-3 items-start">
                  <span className="text-[18px] text-[#8a6fd1]">📍</span>
                  <div>
                    <p className="text-[#8a6fd1] text-[14px] md:text-[16px]">
                      Location
                    </p>
                    <p className="text-[14px] md:text-[16px]">Bhubaneswar</p>
                  </div>
                </li>

                <li className="flex gap-3 items-start">
                  <span className="text-[#8a6fd1] text-[18px]">🏠</span>
                  <div>
                    <p className="text-[#8a6fd1] text-[14px] md:text-[16px]">
                      Floors
                    </p>
                    <p className="text-[14px] md:text-[16px]">G+1</p>
                  </div>
                </li>

                <li className="flex gap-3 items-start">
                  <span className="text-[#8a6fd1] text-[18px]">📏</span>
                  <div>
                    <p className="text-[#8a6fd1] text-[14px] md:text-[16px]">
                      Length
                    </p>
                    <p className="text-[14px] md:text-[16px]">30 × 50 sq.ft</p>
                  </div>
                </li>

                <li className="flex gap-3 items-start">
                  <span className="text-[#8a6fd1] text-[18px]">$</span>
                  <div>
                    <p className="text-[#8a6fd1] text-[14px] md:text-[16px]">
                      Budget
                    </p>
                    <p className="text-[14px] md:text-[16px]">80L-90L</p>
                  </div>
                </li>

                <li className="flex gap-3 items-start">
                  <span className="text-[#8a6fd1] text-[18px]">🧭</span>
                  <div>
                    <p className="text-[#8a6fd1] text-[14px] md:text-[16px]">
                      Facing
                    </p>
                    <p className="text-[14px] md:text-[16px]">North</p>
                  </div>
                </li>
              </ul>
              {/* GRID END */}
            </div>
          </div>
        </div>
      </section>
      <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#d7c8f2] via-[#c5b7ea] to-[#e5b5d6] px-4 py-10">
        <div className="max-w-[900px] w-full text-center">
          {/* TITLE */}
          <h2 className="text-[24px] md:text-[28px] font-semibold">
            You Dream. We Deliver.
          </h2>

          <p className="text-gray-600 text-[13px] md:text-[14px] mt-2 mb-8">
            Ready to build your dream home? Schedule a free consultation to
            start your journey today.
          </p>

          {/* CARD */}
          <div className="bg-[#f3f3f3] p-6 md:p-8 rounded-xl shadow-sm">
            <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* INPUTS */}
              <input
                type="text"
                placeholder="Full Name"
                className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400"
              />

              <input
                type="email"
                placeholder="Email"
                className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400"
              />

              <input
                type="tel"
                placeholder="Mobile Number"
                className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400"
              />

              <select className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400">
                <option>Choose City</option>
                <option>Bhubaneswar</option>
                <option>Cuttack</option>
                <option>Delhi</option>
              </select>

              {/* FLOATING LABEL FIELD */}
              <div className="relative md:col-span-1">
                <label className="absolute -top-2 left-3 bg-[#f3f3f3] px-1 text-[11px] text-gray-500">
                  I want to start conversation in
                </label>

                <select className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400">
                  <option>0-3 months</option>
                  <option>3-6 months</option>
                  <option>6-12 months</option>
                </select>
              </div>

              {/* RADIO */}
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 text-sm">
                <p>Do you own a plot or land?</p>

                <div className="flex gap-4">
                  <label className="flex items-center gap-2">
                    <input type="radio" name="land" />
                    Yes
                  </label>

                  <label className="flex items-center gap-2">
                    <input type="radio" name="land" />
                    No
                  </label>
                </div>
              </div>

              {/* CHECKBOX */}
              <div className="flex items-start gap-2 md:col-span-2 text-[12px] text-gray-600">
                <input type="checkbox" className="mt-1" />
                <p>
                  I agree to{" "}
                  <span className="text-purple-600 cursor-pointer">
                    Privacy Policy
                  </span>{" "}
                  and{" "}
                  <span className="text-purple-600 cursor-pointer">
                    Terms & Conditions
                  </span>
                </p>
              </div>

              {/* BUTTON */}
              <button className="md:col-span-2 w-full py-3 rounded-lg text-white text-sm font-medium bg-gradient-to-r from-purple-300 to-purple-500 hover:opacity-90 transition">
                Book a meeting
              </button>
            </form>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
